import { useNode } from "@craftjs/core";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";

import {
  PaddingWrapper,
  StyledContentContainer,
} from "./paragraph-picture-option-2-component-styles";

type ParagraphPictureOption2Props = {
  children: React.ReactNode;
};

export default function ParagraphPictureOption2(
  props: ParagraphPictureOption2Props
) {
  const {
    connectors: { connect },
    id,
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={id}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper>
          <StyledContentContainer>{props.children}</StyledContentContainer>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

ParagraphPictureOption2.craft = {
  isCanvas: true,
  custom: {
    displayName: "Paragraph & Picture Option 2",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
